 //sidebar fixed
  $(document).ready(function(){
    if ($(window).width() > 1200) {
      //fix_sidebar();
    }
  });
  function isOnScreen(elem) {
      // if the element doesn't exist, abort
      if( elem.length == 0 ) {
          return;
      }
      var $window = jQuery(window)
      var viewport_top = $window.scrollTop()
      var viewport_height = $window.height()
      var viewport_bottom = viewport_top + viewport_height
      var $elem = jQuery(elem)
      var top = $elem.offset().top
      var height = $elem.height()
      var bottom = top + height
      return (top >= viewport_top && top < viewport_bottom) ||
      (bottom > viewport_top && bottom <= viewport_bottom) ||
      (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
  }
  jQuery( document ).ready( function() {
      window.addEventListener('scroll', function(e) {
          if( isOnScreen( jQuery( '.site-footer' ) )  ) { /* Pass element id/class you want to check */
              $('body').removeClass('installtion-fixed');
            $('#sidebar2').removeClass('fixed');
          } 
       
          
      
      });
});

$(window).scroll(function(){
    if ($(window).scrollTop() >= 200) {
        $('#sidebar2').addClass('fixed');
       $('body').addClass('installtion-fixed');
    }
    else {
        $('#sidebar2').removeClass('fixed');
       $('body').removeClass('installtion-fixed');
    }
});

  $(document).ready(function(){

     $(".filter__mobile--title").click(function(){
       $(this).toggleClass('active');
    $(".customize-sidebar").toggleClass('show-filter');
  });
  });


$('.img-thubmnails').each(function(){
    $(this).find('.img-container').first().addClass('active');
});

// $('.img-thubmnails .img-container').first().addClass('active');
$(".img-container img").hover(function () {
    var src = $(this).attr("src");
    $(this).parents(".steps-info-block").find(".main-img-container img").attr("src", src);
//  $(".img-container").removeClass('active');
    if($(this).parent('.img-container').siblings().hasClass('active')){
        $(this).parent('.img-container').siblings().removeClass('active');
    }
    $(this).parent('.img-container').addClass('active');
//   $(".main-img-container img").attr("src", src);
});